<template>
  <div>
    <Header
      :title="$t('projects.createProject').toString()"
      :show-back-button="true"
      :items="headerButtons"
      @back="$router.push({ name: 'projectSettingsProjects' })"
      @save="storeProject"
    />
    <div class="card card-custom">
      <div class="card-body">
        <FormHelper
          ref="form"
          v-model="project"
          :form="form"
          :config="config"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Projects from "@/components/Settings/Projects/project";
import { LOAD_PROJECTS } from "@/core/services/store/switchArea.module";
import Header from "@/components/Tools/Header/Header.vue";
import FormHelper from "@/components/Tools/FormHelper/FormHelper.vue";
import {
  addEventToLoadingQueue,
  removeEventFromLoadingQueue
} from "@/composables/useLoadingQueue";

export default {
  name: "ProjectsSettingsProjectsCreate",
  components: { FormHelper, Header },
  data() {
    return {
      headerButtons: [
        {
          type: "button",
          title: this.$t("general.save"),
          emit: "save"
        }
      ],
      config: {
        snippetPrefix: "project",
        enableVariables: false
      },
      form: [
        {
          label: this.$t("projects.name"),
          name: "name",
          type: "text",
          disableReturnType: true,
          default: "",
          validations: {
            required: true,
            minLength: 3
          }
        },
        {
          label: this.$t("general.active"),
          name: "active",
          type: "checkbox"
        },
        {
          label: this.$t("projects.description"),
          name: "description",
          type: "textarea",
          default: "",
          validations: {
            required: false
          }
        }
      ],
      project: {
        name: "",
        description: "",
        active: true
      }
    };
  },
  methods: {
    storeProject() {
      addEventToLoadingQueue({ key: "storeProject" });
      let project = this.project;

      Projects.store(project)
        .then(response => {
          this.project = response.data;
          removeEventFromLoadingQueue({
            key: "storeProject",
            type: "success",
            prefix: "projects",
            name: "saved",
            data: { name: this.project.name }
          });

          this.$store.dispatch(LOAD_PROJECTS);
          this.$router.push({
            name: "projectSettingsProjectsDetails",
            params: { projectId: this.project.id }
          });
        })
        .catch(error => {
          this.$error(error);
        });
    }
  }
};
</script>
